// extracted by mini-css-extract-plugin
export default {"root":"HRANgKSvXnT1fwpKhIzM","wrap":"OkcI93oRNznVNGe3UQEA","title":"fzci_XR2YJy6HPWh8DsX","copy":"Abxl7btWHawc_w7HyVRg","btn":"ys53_2Uk685dAxbwBUTs"};